import React, { createContext, useContext, useState } from "react";

// --- Configuration ---

// LocalStorage keys for persistence
export const LS_KEYS = {
  WS_URL: "APP_WS_URL",
  WS_TOKEN: "APP_WS_TOKEN",
};

// Default values if LocalStorage is empty
const DEFAULT_SETTINGS = {
  wsUrl: "ws://localhost:1234",
  wsToken: "",
};

const SettingContext = createContext();

// --- Provider Component ---

export const SettingProvider = ({ children }) => {
  // Initialize state lazily from LocalStorage to avoid UI flickering
  const [settings, setSettings] = useState(() => {
    try {
      return {
        wsUrl: localStorage.getItem(LS_KEYS.WS_URL) || DEFAULT_SETTINGS.wsUrl,
        wsToken: localStorage.getItem(LS_KEYS.WS_TOKEN) || DEFAULT_SETTINGS.wsToken,
      };
    } catch (error) {
      console.error("Settings load error:", error);
      return DEFAULT_SETTINGS;
    }
  });

  // Update state and sync changes to LocalStorage
  const updateSettings = (newSettings) => {
    setSettings((prev) => {
      const updated = { ...prev, ...newSettings };

      if (newSettings.wsUrl !== undefined) localStorage.setItem(LS_KEYS.WS_URL, newSettings.wsUrl);
      if (newSettings.wsToken !== undefined) localStorage.setItem(LS_KEYS.WS_TOKEN, newSettings.wsToken);

      return updated;
    });
  };

  // Reset settings to default values
  const resetSettings = () => {
    updateSettings(DEFAULT_SETTINGS);
  };

  return (
    <SettingContext.Provider value={{ settings, updateSettings, resetSettings, LS_KEYS }}>
      {children}
    </SettingContext.Provider>
  );
};

// --- Custom Hook ---

export const useSettings = () => {
  const context = useContext(SettingContext);
  if (!context) {
    throw new Error("useSettings must be used within a SettingProvider");
  }
  return context;
};